"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../../../ui-components/inline-icon/inline-icon"));
var card_scss_1 = tslib_1.__importDefault(require("../../card.scss"));
var card_content_scss_1 = tslib_1.__importDefault(require("./card-content.scss"));
var ScheduledIcon_1 = tslib_1.__importDefault(require("../../../../../../../icons/compiled/components/ScheduledIcon"));
var TriangleIcon_1 = tslib_1.__importDefault(require("../../../../../../../icons/compiled/components/TriangleIcon"));
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var VideoCardContent = /** @class */ (function (_super) {
    tslib_1.__extends(VideoCardContent, _super);
    function VideoCardContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoCardContent.prototype.isLiveVideo = function () {
        var itemType = this.props.cardData.itemType;
        return itemType === item_type_1.ItemType.ItemLive;
    };
    VideoCardContent.prototype.isScheduledVideo = function () {
        var itemType = this.props.cardData.itemType;
        return itemType === item_type_1.ItemType.ItemScheduled;
    };
    VideoCardContent.prototype.renderThumbnail = function () {
        var cardData = this.props.cardData;
        var thumbnailUrl = cardData.thumbnailUrl;
        if (!thumbnailUrl) {
            return this.isScheduledVideo() ? this.renderScheduledPlaceholder() : null;
        }
        return (react_1.default.createElement("div", { className: card_scss_1.default.thumbnail },
            react_1.default.createElement("div", { className: card_scss_1.default.image, style: { backgroundImage: "url(".concat(thumbnailUrl, ")") } }),
            this.renderThumbnailIcon()));
    };
    VideoCardContent.prototype.renderThumbnailIcon = function () {
        if (this.isLiveVideo()) {
            return react_1.default.createElement("div", { className: card_content_scss_1.default['thumbnail-circle'] });
        }
        return (react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(TriangleIcon_1.default, null), className: card_content_scss_1.default['thumbnail-icon'] }));
    };
    VideoCardContent.prototype.renderScheduledPlaceholder = function () {
        return (react_1.default.createElement("div", { className: card_scss_1.default.thumbnail },
            react_1.default.createElement("div", { className: card_content_scss_1.default['scheduled-placeholder'] },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ScheduledIcon_1.default, null), className: card_content_scss_1.default['scheduled-icon'] }))));
    };
    VideoCardContent.prototype.renderText = function () {
        var cardData = this.props.cardData;
        var text = cardData.text;
        return (react_1.default.createElement("div", { className: card_scss_1.default.text },
            react_1.default.createElement("div", { className: card_scss_1.default['text-content'], "data-hook": "action-card-title" }, text)));
    };
    VideoCardContent.prototype.renderScheduledText = function () {
        var cardData = this.props.cardData;
        var text = cardData.text, liveLabel = cardData.liveLabel;
        return (react_1.default.createElement("div", { className: card_content_scss_1.default['scheduled-text'] },
            react_1.default.createElement("span", { className: card_content_scss_1.default['scheduled-time'] }, liveLabel),
            react_1.default.createElement("div", { className: card_content_scss_1.default['scheduled-title'], "data-hook": "action-card-title" }, text)));
    };
    VideoCardContent.prototype.renderCtaIcon = function () {
        if (this.isLiveVideo()) {
            return react_1.default.createElement("div", { className: card_content_scss_1.default['cta-circle'] });
        }
        return (react_1.default.createElement("span", { className: (0, classnames_1.default)(card_scss_1.default['cta-icon-container'], card_scss_1.default['cta-play-container']) },
            react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(TriangleIcon_1.default, null), className: card_scss_1.default['icon-play'] })));
    };
    VideoCardContent.prototype.renderCta = function () {
        var cardData = this.props.cardData;
        var buttonLabel = cardData.buttonLabel;
        return (react_1.default.createElement("div", { className: card_scss_1.default.cta },
            this.renderCtaIcon(),
            react_1.default.createElement("div", { className: card_scss_1.default['cta-label'], "data-hook": "action-card-action-text" }, buttonLabel)));
    };
    VideoCardContent.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, isAriaHidden = _b.isAriaHidden;
        var isScheduledVideo = this.isScheduledVideo();
        var contentClassName = (0, classnames_1.default)(className, (_a = {},
            _a[card_scss_1.default.live] = this.isLiveVideo(),
            _a[card_scss_1.default.scheduled] = isScheduledVideo,
            _a));
        return (react_1.default.createElement("div", { className: contentClassName, "aria-hidden": isAriaHidden },
            this.renderThumbnail(),
            react_1.default.createElement("div", { className: card_scss_1.default.container },
                isScheduledVideo ? this.renderScheduledText() : this.renderText(),
                !isScheduledVideo && this.renderCta())));
    };
    VideoCardContent.propTypes = {
        cardData: prop_types_1.default.object,
        className: prop_types_1.default.string,
        isAriaHidden: prop_types_1.default.bool,
    };
    return VideoCardContent;
}(react_1.default.Component));
exports.default = VideoCardContent;
//# sourceMappingURL=card-content.js.map